import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { getApiUrl } from '../config/api'
import '../App.css'

function Navbar() {
  const location = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)
  const [pages, setPages] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(getApiUrl('pages'))
      .then(response => response.json())
      .then(data => {
        setPages(data)
        setLoading(false)
      })
      .catch(error => {
        console.error('Error fetching pages:', error)
        setLoading(false)
      })
  }, [])

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="navbar-brand">
          <i className="fas fa-graduation-cap"></i>
          <span>SkillSiksha</span>
        </Link>
        <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </button>
        <ul className={`navbar-nav ${menuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={() => setMenuOpen(false)}>Home</Link>
          </li>
          {!loading && pages.map((page) => {
            const path = page.link || `/${page.slug || page.title.toLowerCase().replace(/\s+/g, '-')}`
            return (
              <li key={page.id}>
                <Link 
                  to={path} 
                  className={location.pathname === path || location.pathname === `/${page.slug}` ? 'active' : ''} 
                  onClick={() => setMenuOpen(false)}
                >
                  {page.title}
                </Link>
              </li>
            )
          })}
          <li>
            <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''} onClick={() => setMenuOpen(false)}>Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar

